<template>
    <div class="img-color-overlay">
        <div class="container">
            <div class="row section-separator">
                <div class="col-sm-12 section-title wow fadeInUp" data-wow-duration="0.6s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.6s; animation-delay: 0.2s; animation-name: none;">
                    <h3>{{ $t('friendship.friendshipLinks') }}</h3>
                </div>
            </div>
            <div class="row  text-left mb-16 section-title wow fadeInUp" data-wow-duration="1.0s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 1.0s; animation-delay: 0.2s; animation-name: none;">
                <!-- ----------------------------------------------------- -->
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://moyu.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/moyu.png" alt="摸鱼办" />
                            </v-avatar>
                            <a>摸鱼办</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://hxp.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/hxp.png" alt="沪小漂" />
                            </v-avatar>
                            <a>沪小漂</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://yimei.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/yimei-white.png" alt="逸玫工作室" />
                            </v-avatar>
                            <a>逸玫工作室</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://blog.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/lx.jpg" alt="一个正经的程序员" />
                            </v-avatar>
                            <a>一个正经的程序员</a>
                        </a>
                    </h5>
                </div>
                <!-- <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://nav.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/bookmark-nav.jpg" alt="书签导航" />
                            </v-avatar>
                            <a>书签导航</a>
                        </a>
                    </h5>
                </div> -->
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://sri.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/sri-calculator.png" alt="性压抑指数计算器" />
                            </v-avatar>
                            <a>性压抑指数计算器</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://merkle.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/merkle-tree-converter.svg" alt="Merkle Tree Converter" />
                            </v-avatar>
                            <a>Merkle Tree Converter</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://chat.liuxin.online" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="/static/images/friendship/lx.jpg" alt="ChatGPT-LX" />
                            </v-avatar>
                            <a>ChatGPT-LX</a>
                        </a>
                    </h5>
                </div>
                <div class="col-sm-12 col-md-3">
                    <h5>
                        <a href="https://www.mochengli.cn" target="_black">
                            <v-avatar size="36" class="mr-3">
                                <img src="https://www.mochengli.cn/avatar/none.jpg" alt="陌橙离家的小屋" />
                            </v-avatar>
                            <a>陌橙离家的小屋</a>
                        </a>
                    </h5>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FriendshipLink.vue